<tr [formGroup]="ratingForm">
    <td class="competency-name">
        <br>
        {{ ('SUPERVISION.COMPETENCY_QUESTIONNAIRE.FORM.'+step+"_FORM."+labelMap.title) | translate }}
        <br>
        <br>
        <br>
        <i *ngIf="labelMap.description!=undefined&&labelMap.description!=null">
            {{ 'SUPERVISION.COMPETENCY_QUESTIONNAIRE.NOTE' | translate }}:
            {{ ('SUPERVISION.COMPETENCY_QUESTIONNAIRE.FORM.'+step+"_FORM."+labelMap.description) | translate }}
        </i>
    </td>
    <td class="competency-rating">
        <mat-form-field appearance="outline">
            <mat-label>
                {{ 'SUPERVISION.COMPETENCY_QUESTIONNAIRE.RATING' | translate }}
            </mat-label>
            <mat-select formControlName="rating">
                <mat-option *ngFor="let r of ratings" [value]="r">{{ r }}</mat-option>
            </mat-select>
        </mat-form-field>
    </td>
    <td class="competency-comment">
        <field-holder>
            <mat-form-field appearance="outline">
                <mat-label>{{ 'SUPERVISION.COMPETENCY_QUESTIONNAIRE.COMMENT' | translate }}</mat-label>
                <textarea matInput rows="3" formControlName="comment"></textarea>
            </mat-form-field>
        </field-holder>
    </td>
</tr>